
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetAccountTypeEnum } from '../models/work-budget-account-type-enum';
import { requiredBoolean } from './required-boolean.validator';
import { WorkBudgetReportMonthValueDto } from '../models/work-budget-report-month-value-dto';

export function getBudgetReportRowDtoFormGroup() {
return new FormGroup({
    budgetAccountId: new FormControl<number | undefined>(undefined, [Validators.required]),
    accountName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    accountType: new FormControl<WorkBudgetAccountTypeEnum | undefined>(undefined, [Validators.required]),
    businessdivisionId: new FormControl<number | undefined>(undefined),
    isAdditive: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    monthlyValues: new FormControl<WorkBudgetReportMonthValueDto[]>([]),
    sollTotal: new FormControl<number | undefined>(undefined, [Validators.required]),
    istTotal: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      